




import {Component, Prop} from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import SpecOutStatus from '@/models/SpecOuts/SpecOutStatus';
import StatusDisplayLocation from '@/models/Shared/StatusDisplayLocation';

@Component({
  name: 'SpecOutStatus',
})
export default class extends GiganautVue {

	@Prop({required: true})
	status: SpecOutStatus;

	@Prop({required: true})
	location: StatusDisplayLocation;

	get textColor() {
		let color = "black--text";
		switch (this.status) {
			case SpecOutStatus.Draft:
				color = "orange--text"
				break;
			case SpecOutStatus.Sent:
				color = "green--text"
				break;
			default:
				color = "black-text"
				break;
		}
		return color;
	}

	get text() {
		let text = "";
		switch (this.status) {
			case SpecOutStatus.Draft:
				text = "DRAFT";
				break;
			case SpecOutStatus.Sent:
				text = "SENT"
				break;
			default:
				text = "UNKNOWN STATUS"
				break;
		}
		return text;
	}

	get classy() {
		const classes: string[] = [this.textColor]
		switch (this.location) {
			case StatusDisplayLocation.Title:
				classes.push("overline");
				classes.push("ma-2");
				break;
			case StatusDisplayLocation.Grid:
				classes.push("overline");
				break;
			case StatusDisplayLocation.SubTitle:
			default:
				classes.push("overline");
				classes.push("ma-2");
				break;
		}
		return classes;
	}
}
